import React from 'react'
import NavLink from '../Routes/NavLink'

import CanvasComponent from '../Graphics/CanvasComponent.jsx'
import {buildingRenderer} from '../../core/graphic_engine/controllers/building.js'
import THREE from 'particlespace-graphics-engine'

import { buildings } from '../../core/controllers/Buildings'
import { buildingStatistics } from '../../helpers/Building/BuildingStatistics'
import { buildingControllers } from '../../core/controllers/BuildingControllers'
import { buildingCameras } from '../../core/controllers/BuildingCameras'

export default class BuildingCard extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            updateCanvas: false,
            renderer: new THREE.CanvasRenderer(),
            canvasID: "building-card-holder",
            totalLateRent: 0,
            totalMaintenance: 0,
            avgTemp: buildingControllers.currentAvgTemp,
            totalDoorsOpened: 0,
            totalDoorsClosed: 0,
            cameras: null,
            hasIntegrations: false,
            hasCameras: false,
            hasAccessControl: false
        }
    }

    componentDidMount() {
        if(this.props.buildingData) {
            var self = this;
            buildingRenderer.createMini3DBuildingModel(this,this.props.buildingMetaData.building_floor_plan_data.floor_plan_model, this.props.buildingData.building_level_total, this.props.buildingMetaData.level_states);
            buildings.getBuildingStatistics(this.props.buildingData.building_id, function(response) {
                buildingStatistics.determineStatistics(response.data, function() {
                    self.setState({
                        totalLateRent: buildingStatistics.totalLateRent,
                        totalMaintenance: buildingStatistics.totalMaintenance,
                        totalDoorsOpened: buildingStatistics.totalDoorsOpened,
                        totalDoorsClosed: buildingStatistics.totalDoorsClosed,
                        hasIntegrations: response.meta_data.has_integrations,
                        hasCameras: response.meta_data.has_cameras,
                        hasAccessControl: response.meta_data.has_access_controls
                    })
                });
            });
        }
    }

    componentWillUpdate(nextProps, nextState) {
        if(this.state.hasCameras == false && nextState.hasCameras) {
            this.checkCameras(true);
        }
    }

    buildingInsights() {
        buildingControllers.determineAvgTemp();
        this.setState({avgTemp: buildingControllers.currentAvgTemp});
    }

    checkCameras(forceLoad = false) {
        var self = this;
        if(this.state.hasCameras || forceLoad) {
            buildingCameras.getCameras(this.props.buildingData.building_id, function(response) {
                self.setState({
                    cameras: response.data,
                });
            });
        }
    }

    render(){
        const buildingDetails = this.props.buildingDetails;
        const buildingData = this.props.buildingData;
        const buildingMetaData = this.props.buildingMetaData;
        const cameras = this.state.cameras;
        var length = 0;

        if(cameras != null) {
            length = cameras.length;
        }

        if(!buildingData) {
            return false;
        }

        return (
            <div class="col-md-4 building-card" key={buildingData.building_id}>
                <NavLink to={"/building/" + buildingData.building_id}>
                    <div class="card">
                        <div class="header">
                            <h4 class="title">{buildingDetails.building_name}</h4>
                            <p class="category">{buildingData.building_level_total} Floors</p>
                        </div>
                        <div class="content">
                            <CanvasComponent domID={this.state.canvasID} classID="ct-chart ct-perfect-fourth" renderer={this.state.renderer} updateCanvas={this.state.updateCanvas}/>
                            <div class="footer">
                                {length <= 1 ? (
                                <div class="legend">
                                    <i class="pe-7s-video text-info"></i> {length} camera&nbsp;&nbsp;&nbsp;
                                    <i class="icon-icons8-thermometer-automation text-info"></i> Average Temp: {this.state.avgTemp}&nbsp;&#8457;
                                </div>
                                ) : (
                                <div class="legend">
                                    <i class="pe-7s-video text-info"></i> {length} cameras&nbsp;&nbsp;&nbsp;
                                    <i class="icon-icons8-thermometer-automation text-info"></i> Average Temp: {this.state.avgTemp}&nbsp;&#8457;
                                </div>
                                )}
                                <hr/>
                                <div class="stats">
                                    <i class="fa fa-clock-o"></i> Last updated {buildingMetaData.formatted_update_time}
                                </div>
                            </div>
                        </div>
                    </div>
                </NavLink>
            </div>
        )
    }
};


// WEBPACK FOOTER //
// app/components/Building/BuildingCard.jsx